/* eslint-disable camelcase */

// บาง record เก็บ firstname_th/lastname_th เป็น "-" (หรือช่องว่าง) แทนที่จะเว้นว่างจริง —
// ถือว่า "ไม่มีค่า" เพื่อให้ fallback ไปใช้ firstname/lastname ได้ (ไม่งั้นจะโชว์ "- -")
const clean = (v) => {
  const s = String(v || '').trim();
  return s && !/^-+$/.test(s) ? s : '';
};

export const formatEmployeeThaiName = (employee) => {
  if (!employee) return '';

  const firstname_th = clean(employee.firstname_th);
  const lastname_th = clean(employee.lastname_th);

  if (firstname_th && lastname_th) {
    return `${employee.title || ''}${firstname_th} ${lastname_th}`;
  }

  return [clean(employee.firstname), clean(employee.lastname)].filter(Boolean).join(' ');
};

export default formatEmployeeThaiName;
